export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: { input: string; output: string };
    String: { input: string; output: string };
    Boolean: { input: boolean; output: boolean };
    Int: { input: number; output: number };
    Float: { input: number; output: number };
};

export type ActionCenterAdvertiserDetailsRequest = {
    readonly adAccountId?: InputMaybe<Scalars["String"]["input"]>;
};

export type ActionCenterAdvertiserDetailsResponse = {
    readonly __typename?: "ActionCenterAdvertiserDetailsResponse";
    readonly adAccountIds?: Maybe<ReadonlyArray<Maybe<Scalars["String"]["output"]>>>;
    readonly advertiserId?: Maybe<Scalars["String"]["output"]>;
    readonly advertiserNumber?: Maybe<Scalars["String"]["output"]>;
    readonly brandNames?: Maybe<ReadonlyArray<Maybe<Scalars["String"]["output"]>>>;
    readonly spendUsd90d?: Maybe<Scalars["Float"]["output"]>;
    readonly spendUsdQtd?: Maybe<Scalars["Float"]["output"]>;
    readonly subVerticalL1?: Maybe<Scalars["String"]["output"]>;
    readonly subVerticalL2?: Maybe<Scalars["String"]["output"]>;
    readonly subVerticalL3?: Maybe<Scalars["String"]["output"]>;
    readonly vertical?: Maybe<Scalars["String"]["output"]>;
};

export type AudienceCategory = {
    readonly __typename?: "AudienceCategory";
    readonly count?: Maybe<Scalars["Int"]["output"]>;
    readonly dimensionName?: Maybe<Scalars["String"]["output"]>;
    readonly fieldName?: Maybe<Scalars["String"]["output"]>;
    readonly id?: Maybe<Scalars["String"]["output"]>;
    readonly name?: Maybe<Scalars["String"]["output"]>;
    readonly referenceAudiencePercent?: Maybe<Scalars["Float"]["output"]>;
    readonly targetAudiencePercent?: Maybe<Scalars["Float"]["output"]>;
    readonly targetIndexToReference?: Maybe<Scalars["Float"]["output"]>;
};

export type AudienceDistribution = {
    readonly __typename?: "AudienceDistribution";
    readonly categoriesMap?: Maybe<ReadonlyArray<Maybe<AudienceCategory>>>;
    readonly referenceAudience?: Maybe<AudienceStats>;
    readonly targetAudience?: Maybe<AudienceStats>;
};

export type AudienceStats = {
    readonly __typename?: "AudienceStats";
    readonly audienceSizeMaximum?: Maybe<Scalars["Int"]["output"]>;
    readonly audienceSizeMinimum?: Maybe<Scalars["Int"]["output"]>;
};

export type InsightsAudiencePlannerRequest = {
    readonly fieldFilter?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>>;
    readonly referenceSpec: InsightsTargetingSpecJson;
    readonly specSource?: InputMaybe<SpecSource>;
    readonly targetingSpec: InsightsTargetingSpecJson;
};

export type InsightsAudiencePlannerResponse = {
    readonly __typename?: "InsightsAudiencePlannerResponse";
    readonly data?: Maybe<AudienceDistribution>;
};

export type InsightsRecommendationRequest = {
    readonly adAccountId?: InputMaybe<Scalars["String"]["input"]>;
};

export type InsightsRecommendationResponse = {
    readonly __typename?: "InsightsRecommendationResponse";
    readonly recommendations?: Maybe<ReadonlyArray<Maybe<Scalars["String"]["output"]>>>;
};

export type InsightsTopPublishersResponse = {
    readonly __typename?: "InsightsTopPublishersResponse";
    readonly data?: Maybe<ReadonlyArray<Maybe<InsightsTopPublishersResponseItem>>>;
};

export type InsightsTopPublishersResponseItem = {
    readonly __typename?: "InsightsTopPublishersResponseItem";
    readonly count?: Maybe<Scalars["Int"]["output"]>;
    readonly id?: Maybe<Scalars["String"]["output"]>;
    readonly logoUrl?: Maybe<Scalars["String"]["output"]>;
    readonly name?: Maybe<Scalars["String"]["output"]>;
    readonly referenceAudiencePercent?: Maybe<Scalars["Float"]["output"]>;
    readonly targetAudiencePercent?: Maybe<Scalars["Float"]["output"]>;
    readonly targetIndexToReference?: Maybe<Scalars["Float"]["output"]>;
};

export type InsightsAppInstallStateJson = {
    readonly snap_app_ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>>;
    readonly state?: InputMaybe<InsightsState>;
};

export type InsightsAudienceSegmentSpecJson = {
    readonly ab_segment_id?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>>;
    readonly operation?: InputMaybe<InsightsOperation>;
    readonly segment_id?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>>;
};

export type InsightsAutoExpansionOptionsJson = {
    readonly custom_audience_expansion_option?: InputMaybe<InsightsCustomAudienceExpansionOptionJson>;
    readonly interest_expansion_option?: InputMaybe<InsightsInterestExpansionOptionJson>;
};

export type InsightsCircleSpecJson = {
    readonly latitude?: InputMaybe<Scalars["Int"]["input"]>;
    readonly longitude?: InputMaybe<Scalars["Int"]["input"]>;
    readonly name?: InputMaybe<Scalars["String"]["input"]>;
    readonly radius?: InputMaybe<Scalars["Int"]["input"]>;
    readonly unit?: InputMaybe<InsightsUnit>;
};

export enum InsightsConnectionType {
    Cell = "CELL",
    ConnectionUnknown = "CONNECTION_UNKNOWN",
    Wifi = "WIFI",
}

export type InsightsCustomAudienceExpansionOptionJson = {
    readonly enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export enum InsightsCustomRuleOperator {
    Contains = "CONTAINS",
    DoesntStartWith = "DOESNT_START_WITH",
    Equals = "EQUALS",
    GreaterThan = "GREATER_THAN",
    GreaterThanOrEquals = "GREATER_THAN_OR_EQUALS",
    LessThan = "LESS_THAN",
    LessThanOrEquals = "LESS_THAN_OR_EQUALS",
    NotContains = "NOT_CONTAINS",
    NotEquals = "NOT_EQUALS",
    StartsWith = "STARTS_WITH",
    Unrecognized = "UNRECOGNIZED",
}

export type InsightsDemographicSpecJson = {
    readonly advanced_demographics?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>>;
    readonly age_groups?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>>;
    readonly gender?: InputMaybe<InsightsGender>;
    readonly languages?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>>;
    readonly max_age?: InputMaybe<Scalars["String"]["input"]>;
    readonly min_age?: InputMaybe<Scalars["String"]["input"]>;
    readonly operation?: InputMaybe<InsightsOperation>;
};

export type InsightsDeviceSpecJson = {
    readonly carrier_id?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>>;
    readonly connection_type?: InputMaybe<InsightsConnectionType>;
    readonly marketing_name?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>>;
    readonly operation?: InputMaybe<InsightsOperation>;
    readonly os_type?: InputMaybe<InsightsOsType>;
    readonly os_version_max?: InputMaybe<Scalars["String"]["input"]>;
    readonly os_version_min?: InputMaybe<Scalars["String"]["input"]>;
};

export enum InsightsGender {
    Female = "FEMALE",
    GenderUnknown = "GENDER_UNKNOWN",
    Male = "MALE",
    Other = "OTHER",
}

export type InsightsGeoSpecJson = {
    readonly country_code?: InputMaybe<Scalars["String"]["input"]>;
    readonly electoral_district_id?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>>;
    readonly metro_id?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>>;
    readonly operation?: InputMaybe<InsightsOperation>;
    readonly postal_code?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>>;
    readonly radius?: InputMaybe<Scalars["Int"]["input"]>;
    readonly region_id?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>>;
};

export type InsightsInterestExpansionOptionJson = {
    readonly enabled?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type InsightsInterestSpecJson = {
    readonly id?: InputMaybe<Scalars["String"]["input"]>;
    readonly operation?: InputMaybe<InsightsOperation>;
};

export type InsightsInterestSpecPayload = {
    readonly categoryValues?: InputMaybe<ReadonlyArray<InputMaybe<InsightsInterestSpecJson>>>;
};

export type InsightsLocationSpecJson = {
    readonly circles?: InputMaybe<ReadonlyArray<InputMaybe<InsightsCircleSpecJson>>>;
    readonly location_type?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>>;
    readonly operation?: InputMaybe<InsightsOperation>;
    readonly proximity?: InputMaybe<Scalars["Int"]["input"]>;
    readonly proximity_unit?: InputMaybe<InsightsUnit>;
};

export enum InsightsMaidStatus {
    All = "ALL",
    MaidStatusUnspecified = "MAID_STATUS_UNSPECIFIED",
    NonZeroMaid = "NON_ZERO_MAID",
    ZeroMaid = "ZERO_MAID",
}

export type InsightsMaidStatusSpecJson = {
    readonly maid_status?: InputMaybe<InsightsMaidStatus>;
};

export enum InsightsOperation {
    Exclude = "EXCLUDE",
    Include = "INCLUDE",
}

export enum InsightsOsType {
    Android = "ANDROID",
    OsUnknown = "OS_UNKNOWN",
    IOs = "iOS",
}

export enum InsightsProductAudienceEventType {
    AchievementUnlocked = "ACHIEVEMENT_UNLOCKED",
    AddBilling = "ADD_BILLING",
    AddCart = "ADD_CART",
    AddToWishlist = "ADD_TO_WISHLIST",
    AdClick = "AD_CLICK",
    AdView = "AD_VIEW",
    AppInstall = "APP_INSTALL",
    AppOpen = "APP_OPEN",
    CompleteTutorial = "COMPLETE_TUTORIAL",
    CustomEvent_1 = "CUSTOM_EVENT_1",
    CustomEvent_2 = "CUSTOM_EVENT_2",
    CustomEvent_3 = "CUSTOM_EVENT_3",
    CustomEvent_4 = "CUSTOM_EVENT_4",
    CustomEvent_5 = "CUSTOM_EVENT_5",
    Invite = "INVITE",
    LevelComplete = "LEVEL_COMPLETE",
    ListView = "LIST_VIEW",
    Login = "LOGIN",
    PageView = "PAGE_VIEW",
    Purchase = "PURCHASE",
    Rate = "RATE",
    Reserve = "RESERVE",
    Save = "SAVE",
    Search = "SEARCH",
    Share = "SHARE",
    SignUp = "SIGN_UP",
    SkAdNetworkAssistInstall = "SK_AD_NETWORK_ASSIST_INSTALL",
    SkAdNetworkNullConversionValue = "SK_AD_NETWORK_NULL_CONVERSION_VALUE",
    SpentCredits = "SPENT_CREDITS",
    StartCheckout = "START_CHECKOUT",
    StartTrial = "START_TRIAL",
    Subscribe = "SUBSCRIBE",
    UnknownEvent = "UNKNOWN_EVENT",
    ViewContent = "VIEW_CONTENT",
    Visitation = "VISITATION",
}

export type InsightsProductAudienceSpecJson = {
    readonly event_type?: InputMaybe<InsightsProductAudienceEventType>;
    readonly operation?: InputMaybe<InsightsOperation>;
    readonly product_set?: InputMaybe<Scalars["String"]["input"]>;
    readonly retention_seconds?: InputMaybe<Scalars["Int"]["input"]>;
};

export enum InsightsState {
    All = "ALL",
    Installed = "INSTALLED",
    NotInstalled = "NOT_INSTALLED",
    Unrecognized = "UNRECOGNIZED",
}

export type InsightsTargetingCustomRuleJson = {
    readonly group?: InputMaybe<Scalars["String"]["input"]>;
    readonly key?: InputMaybe<Scalars["String"]["input"]>;
    readonly operator?: InputMaybe<InsightsCustomRuleOperator>;
    readonly value?: InputMaybe<Scalars["String"]["input"]>;
};

export type InsightsTargetingSpecJson = {
    readonly app_install_states?: InputMaybe<ReadonlyArray<InputMaybe<InsightsAppInstallStateJson>>>;
    readonly auto_expansion_options?: InputMaybe<InsightsAutoExpansionOptionsJson>;
    readonly custom_rules?: InputMaybe<ReadonlyArray<InputMaybe<InsightsTargetingCustomRuleJson>>>;
    readonly demographics?: InputMaybe<ReadonlyArray<InputMaybe<InsightsDemographicSpecJson>>>;
    readonly devices?: InputMaybe<ReadonlyArray<InputMaybe<InsightsDeviceSpecJson>>>;
    readonly enable_targeting_expansion?: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly geos?: InputMaybe<ReadonlyArray<InputMaybe<InsightsGeoSpecJson>>>;
    readonly interests?: InputMaybe<InsightsInterestSpecPayload>;
    readonly locations?: InputMaybe<ReadonlyArray<InputMaybe<InsightsLocationSpecJson>>>;
    readonly maid_status_spec?: InputMaybe<InsightsMaidStatusSpecJson>;
    readonly product_audiences?: InputMaybe<ReadonlyArray<InputMaybe<InsightsProductAudienceSpecJson>>>;
    readonly regulated_content?: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly segments?: InputMaybe<ReadonlyArray<InputMaybe<InsightsAudienceSegmentSpecJson>>>;
};

export enum InsightsUnit {
    Feet = "FEET",
    Kilometers = "KILOMETERS",
    Meters = "METERS",
    Miles = "MILES",
}

export type LensMetadata = {
    readonly __typename?: "LensMetadata";
    readonly id?: Maybe<Scalars["String"]["output"]>;
    readonly imageLink?: Maybe<Scalars["String"]["output"]>;
    readonly internalName?: Maybe<Scalars["String"]["output"]>;
    readonly lensPreviewUrl?: Maybe<Scalars["String"]["output"]>;
    readonly publicName?: Maybe<Scalars["String"]["output"]>;
};

export type Query = {
    readonly __typename?: "Query";
    readonly getAudiencePlanner?: Maybe<InsightsAudiencePlannerResponse>;
    readonly getInsightsAdvertiserDetails?: Maybe<ActionCenterAdvertiserDetailsResponse>;
    readonly getInsightsRecommendations?: Maybe<InsightsRecommendationResponse>;
    readonly getInsightsTopPublishers?: Maybe<InsightsTopPublishersResponse>;
    readonly getLensMetadata?: Maybe<ReadonlyArray<Maybe<LensMetadata>>>;
};

export type QueryGetAudiencePlannerArgs = {
    fieldFilter?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>>;
    referenceSpec?: InputMaybe<InsightsTargetingSpecJson>;
    specSource?: InputMaybe<SpecSource>;
    targetingSpec?: InputMaybe<InsightsTargetingSpecJson>;
};

export type QueryGetInsightsAdvertiserDetailsArgs = {
    adAccountId: Scalars["String"]["input"];
};

export type QueryGetInsightsRecommendationsArgs = {
    adAccountId: Scalars["String"]["input"];
};

export type QueryGetInsightsTopPublishersArgs = {
    includeLogoUrl?: InputMaybe<Scalars["Boolean"]["input"]>;
    referenceSpec?: InputMaybe<InsightsTargetingSpecJson>;
    targetingSpec?: InputMaybe<InsightsTargetingSpecJson>;
};

export type QueryGetLensMetadataArgs = {
    ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars["String"]["input"]>>>;
};

export enum SpecSource {
    AudienceFilter = "AUDIENCE_FILTER",
    AudienceLens = "AUDIENCE_LENS",
    Dso = "DSO",
    Experiments = "EXPERIMENTS",
    Fti = "FTI",
    GeoFilter = "GEO_FILTER",
    Internal = "INTERNAL",
    Mpp = "MPP",
    NoSource = "NO_SOURCE",
    PublicUser = "PUBLIC_USER",
}

export type GetTopPublishersRequest = {
    readonly includeLogoUrl?: InputMaybe<Scalars["Boolean"]["input"]>;
    readonly referenceSpec?: InputMaybe<InsightsTargetingSpecJson>;
    readonly targetingSpec?: InputMaybe<InsightsTargetingSpecJson>;
};
